import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Angulartics2Module } from 'angulartics2';
import { GATrackingService } from '~shared/modules/ga-tracking/services';

@NgModule({
  imports: [
    CommonModule,
    Angulartics2Module.forRoot()
  ],
  providers: [
    GATrackingService
  ]
})
export class GATrackingModule {
}
